import { DetailedLabResultObservation } from '@pm/graphql';
import { TFunction } from 'i18next';

export const BACKEND_GROUP_ID_HIV = 'cr5NrYOIfjlBv2j4wqJlZg';
export const BACKEND_GROUP_ID_STI_SCREENING = 'TZaGWL509IkLWVyFWMdZgA';
export const BACKEND_GROUP_ID_HEPATITIS_SEROLOGY = '3Abwj3LSrSz1Btb9okvAcQ';
export const BACKEND_GROUP_ID_KIDNEY_FUNCTION = 'ejpHftBd3-Mb07hA_GWdEQ';
export const BACKEND_GROUP_ID_OTHER = '3zf4kI6RfUyRYd6QXgGy1g';
export const BACKEND_GROUP_ID_SYPHILIS = 'bRXdh7XnMkmyUbWu89Wd6A';
export const BACKEND_GROUP_ID_LIPIDS = 'iNLYp1_bY0ebWL7zQDm1zA';

const SECTIONS: readonly string[] = [
  BACKEND_GROUP_ID_HIV,
  BACKEND_GROUP_ID_STI_SCREENING,
  BACKEND_GROUP_ID_SYPHILIS,
  BACKEND_GROUP_ID_KIDNEY_FUNCTION,
  BACKEND_GROUP_ID_HEPATITIS_SEROLOGY,
  BACKEND_GROUP_ID_LIPIDS,
  BACKEND_GROUP_ID_OTHER,
];

export const KNOWN_RESULTS = new Set([
  'Detected',
  'Not Detected',
  'Non-Reactive',
  'Negative',
  'Positive',
]);

//TODO: Consider dynamic from Resources i18n :  type ObservationInfo = Resources['labs']['TestNames'][keyof Resources['labs']['TestNames']];
export type ObservationTranslationType = {
  Title: string;
  Description: string;
};

export const getTestSectionInfo = (
  sectionId: string,
  t: TFunction<'labs'>,
) => ({
  title: t(`Sections.${sectionId}.Title` as never) as string,
  description: t(`Sections.${sectionId}.Description` as never, {
    defaultValue: '',
  }) as string,
  description2: t(`Sections.${sectionId}.Description2` as never, {
    defaultValue: '',
  }) as string,
});

export const getSortedCategories = (): string[] => [...SECTIONS];

const resolveSectionId = (groupId: string | null | undefined): string =>
  groupId && SECTIONS.includes(groupId) ? groupId : BACKEND_GROUP_ID_OTHER;

export const getLabResultsCategorization = (
  observations: DetailedLabResultObservation[],
) => {
  const buckets: Record<string, DetailedLabResultObservation[]> =
    Object.fromEntries(SECTIONS.map((id) => [id, []]));

  observations.forEach((observation) => {
    const sectionId = resolveSectionId(observation.groupId);
    buckets[sectionId].push(observation);
  });

  return buckets;
};
